import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_SIGNED_DOCUMENT_TEMPLATE } from "../keys";
import { getSignedDocumentTemplate } from "../../../services/signedDocuments";
import { ISignedDocumentTemplateResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";

export const useQuerySignedDocumentTemplate = (
  id: string,
  queryConfig?: WSQueryConfig<ISignedDocumentTemplateResponse, unknown>
) =>
  useWSQuery(
    [QUERY_SIGNED_DOCUMENT_TEMPLATE, id],
    () => getSignedDocumentTemplate(id),
    {
      retry: false,
      ...queryConfig
    }
  );
